import T from '@wojtekmaj/react-t';
import { ScanBarcodeIcon } from 'lucide-react';

import colors from '@rewardopl/styles/colors';

import { Text, Wrapper } from './daily_limit_reached.styles';

export default function DailyLimitReached() {
  return (
    <Wrapper>
      <ScanBarcodeIcon color={colors['secondary-dark']} />
      <Text>
        <T>Daily transaction limit reached. See you tomorrow :)</T>
      </Text>
    </Wrapper>
  );
}
